// @ts-nocheck

import styled from 'styled-components';
import { Panel as LayoutPanel } from '../../components/layout';

export const Panel = styled(LayoutPanel).withConfig({ displayName: "elements__Panel", componentId: "sc-ybuw7z-0" })(["padding-top:0;"]);



export const SectionContent = styled.div.withConfig({ displayName: "elements__SectionContent", componentId: "sc-ybuw7z-1" })(["padding:16px;"]);
